import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import MuvikaService from './../services/muvika';
import { subscribeWithSelector } from 'zustand/middleware';
import bgPerformanceStore from './bgPerformance';
import IntervalService from './../services/intervals';
import messageStore from './message';

const initialState = {
  isWaiting: false,
  isWaitingForNextPrev: false,
  isPlaying: { isPlaying: false, triggerFade: false },
  isPaused: { isPaused: true, triggerFade: false },
  currentPerformanceId: null,
  isMusicOn: false,
  currentTrack: {},
  currentTime: 0,
  from: 0,
  currentBuffer: 0,
  currentVolume: {currentVolume: 0, doNotPropagate: false},
  fadeVolume: 0,
  setterVolume: 0,
  streamUrl: "",
  isFading: false,
  isMusicReallyPaused: { isPaused: true },
  isTrackLogSent: { isTrackLogSent: false },
};

const musicPlayerStore = create(subscribeWithSelector((set, get) => ({
  ...initialState,
  reset: () => {


    set(initialState);
  },
  setIsTrackLogSent: (isSent) => {
    set({ isTrackLogSent: { isTrackLogSent: isSent } });
  },
  setCurrentBuffer: (buffer) => {
    set({ currentBuffer: buffer });
  },
  setIsMusicOn: (isOn) => {
    set({ isMusicOn: isOn });
  },
  setIsFading: (isFading) => {
    set({ isFading: isFading });
  },
  softReset: () => {
    set({
      isWaiting:false,
      isPlaying: { isPlaying: false },
      isStopped: { isStopped: true },
      currentTrack: null,
      currentTime: 0,
      from: { from: 0 },
      currentPerformanceId: null,
      currentBuffer: 0,
      streamUrl: "",
      isMusicReallyPaused: { isPaused: true },
    });
  },
  empty: () => {
    set({ isPlaying: { isPlaying: false }, currentTrack: null, streamUrl: "", currentTime: 0 });
  },
  getStreamUrl: (sessionToken, currentPerformance, track, profile, isPaused = false) => {
    set({isWaiting: true});
    MuvikaService.getStreamUrl(sessionToken, track.track_id, 0, "normal")
      .then(function (res) {
        console.log(res);
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          set({ streamUrl: "", isWaiting: false });
          if (res.data.error.code == 9) {
            bgPerformanceStore.getState().addPerformanceToHistory(sessionToken, currentPerformance);
            bgPerformanceStore.getState().deletePerformance(sessionToken, currentPerformance.unique_id);
          } else {
            let timeout = setTimeout(() => get().getStreamUrl(sessionToken, currentPerformance, track, profile), 5000);
            IntervalService.addStreamUrlTimeout(timeout);
          }
        } else {
          set({ currentTrack: track, currentTime: 0, currentPerformanceId: currentPerformance.unique_id, streamUrl: res.data.data.url, isWaiting: false });
          console.log("stream_url_get", get().currentPerformanceId)
        }
      })
      .catch(function (err) { 
        set({ isSet: false, streamUrl: "", currentTime: 0, isPaused: { isPaused: true }}); 
        if(get().currentPerformanceId && get().currentPerformanceId !== currentPerformance.unique_id){
          set({isPaused: { isPaused: false }})
          let timeout = setTimeout(() => get().getStreamUrl(sessionToken, currentPerformance, track, profile), 5000);
          IntervalService.addStreamUrlTimeout(timeout);
        }
      });
  },
  setCurrentTime: (time) => {
    set({ currentTime: time });
  },
  setIsWaitingForNextPrev: (isWaitingForNextPrev) => {
    set({ isWaitingForNextPrev: isWaitingForNextPrev });
  },
  setIsPlaying: (isPlaying, triggerFade = true) => {
    set({ isPlaying: { isPlaying: isPlaying, triggerFade: triggerFade } });
  },
  setIsPaused: (isPaused, triggerFade = true) => {
    set({ isPaused: { isPaused: isPaused, triggerFade: triggerFade } });
  },
  setIsMusicReallyPaused: (isPaused) => {
    set({ isMusicReallyPaused: { isPaused: isPaused } });
  },
  setFrom: (from) => {
    set({ from: { from: from } });
  },
  setVolume: (volume, doNotPropagate=false) => {
    set({ currentVolume: { currentVolume: volume, doNotPropagate: doNotPropagate}, fadeVolume: volume });
  },
  setFadeVolume: (volume) => {
    set({ fadeVolume: volume });
  },
  setSetterVolume: (volume) => {
    set({ setterVolume: volume });
  },
})));

export default musicPlayerStore;